<template>
  <div class="breadcrumb">
    <span class="crumb" :class="{ active: stack.length === 0 }" @click="$emit('navigate', -1)">
      Root
    </span>
    <template v-for="(item, index) in stack">
      <span :key="`separator-${item.id}`" class="separator">/</span>
      <span
        :key="`crumb-${item.id}`"
        class="crumb"
        :class="{ active: index === stack.length - 1 }"
        @click="$emit('navigate', index)"
        :title="item.description"
      >
        {{ item.description || `Subproject ${item.id}` }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: "BreadcrumbNavigation",
  props: {
    stack: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  font-size: 14px;
}

.crumb {
  cursor: pointer;
  color: #0d47a1;
  text-decoration: underline;
}

.crumb.active {
  font-weight: 600;
  text-decoration: none;
  cursor: default;
}

.separator {
  color: #9e9e9e;
  font-weight: 600;
}
</style>
